import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Career from './pages/Career';
import Services from './pages/Services';
import Solutions from './pages/Solutions'; // Import Solutions page
import Contact from './pages/Contact';
import TracknTone from './pages/TracknTone';
import TracknTonePrivacy from './pages/TracknTonePrivacy';
import TracknToneTerms from './pages/TracknToneTerms';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/career" element={<Career />} />
          <Route path="/services" element={<Services />} />
          <Route path="/solutions" element={<Solutions />} /> {/* New Solutions Route */}
          <Route path="/contact" element={<Contact />} />
          {/* OAuth app-domain pages for TracknTone */}
          <Route path="/trackntone" element={<TracknTone />} />
          <Route path="/trackntone/privacy" element={<TracknTonePrivacy />} />
          <Route path="/trackntone/terms" element={<TracknToneTerms />} />
          {/* Add a fallback route for 404 */}
          <Route path="*" element={<h1>404 - Page Not Found</h1>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;